module.exports = __webpack_public_path__ + "static/media/lifestyle.6e37aee4.svg";